import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

export function fetchQuestionnaireCard({ languageId }) {
  return axiosRequest(
    'get',
    serviceUrls.QUESTIONNAIRE_GET_CARD,
    {
      languageId,
    },
    { timeout: 180000 },
  );
}

export function fetchQuestionnaireIntro({ assigneeServicePlanGlobalId, organizerTypeId, yearTypeId, languageId }) {
  const isCalWP = sessionStorage.getItem('isCalWP');
  return axiosRequest(
    'get',
    serviceUrls.QUESTIONNAIRE_GET_INTRO,
    {
      assigneeServicePlanGlobalId,
      organizerTypeId,
      yearTypeId,
      languageId,
      isCalWP,
    },
    { timeout: 180000 },
  );
}

export function fetchQuestionnaireSection({ assigneeServicePlanGlobalId, organizerTypeId, yearTypeId, languageId, sectionName }) {
  const isCalWP = sessionStorage.getItem('isCalWP');
  return axiosRequest(
    'get',
    serviceUrls.QUESTIONNAIRE_GET_SECTION,
    {
      assigneeServicePlanGlobalId,
      organizerTypeId,
      yearTypeId,
      languageId,
      sectionName,
      isCalWP,
    },
    { timeout: 180000 },
  );
}

export function createTaxChatQuestionnaireService(data = {}) {
  return axiosRequest('post', serviceUrls.CREATE_TAXCHAT_QUESTIONNAIRE, data);
}
